import { createContext, useContext, useState, type ReactNode, type FormEvent } from "react";

const SESSION_KEY = "dsyde.frontend.user";

interface AuthCtx { user: string | null; login: (u: string, p: string) => Promise<string | null>; logout: () => void; }
const Ctx = createContext<AuthCtx>({ user: null, login: async () => "err", logout: () => { } });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<string | null>(() => sessionStorage.getItem(SESSION_KEY));

  const login = async (username: string, password: string): Promise<string | null> => {
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const data = await res.json();
    if (res.ok) { sessionStorage.setItem(SESSION_KEY, data.user); setUser(data.user); return null; }
    return data.error ?? "Errore";
  };

  const logout = () => { sessionStorage.removeItem(SESSION_KEY); setUser(null); };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true); setError(null);
    const err = await login(username, password);
    if (err) { setError(err); setLoading(false); }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--ground)",
    }}>
      <div style={{
        background: "var(--surface)", border: "1px solid var(--hair)", borderRadius: 8,
        width: "min(360px, 94vw)", overflow: "hidden",
      }}>
        <div style={{
          background: "var(--ground)", padding: "2rem 2rem 1.6rem",
          borderBottom: "1px solid var(--hair)",
          display: "flex", flexDirection: "column", alignItems: "center", gap: "0.4rem",
        }}>
          <span style={{ fontFamily: "var(--mono)", fontSize: "0.75rem", letterSpacing: "0.18em", color: "var(--ink)", fontWeight: 500 }}>
            BVLGARI
          </span>
          <span style={{ fontFamily: "var(--mono)", fontSize: "0.5625rem", letterSpacing: "0.1em", color: "var(--ink-3)" }}>
            Alessandria
          </span>
        </div>

        <form onSubmit={submit} style={{ padding: "1.8rem 2rem", display: "flex", flexDirection: "column", gap: "1.2rem" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
            <label style={{ fontFamily: "var(--mono)", fontSize: "0.6875rem", letterSpacing: "0.08em", color: "var(--ink-3)" }}>
              UTENTE
            </label>
            <input
              type="text" value={username} autoComplete="username" autoFocus
              onChange={e => setUsername(e.target.value)}
              style={{
                fontFamily: "var(--mono)", fontSize: "0.875rem", padding: "0.55rem 0.75rem",
                border: "1px solid var(--hair)", borderRadius: 4, background: "var(--ground)",
                color: "var(--ink)", outline: "none",
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
            <label style={{ fontFamily: "var(--mono)", fontSize: "0.6875rem", letterSpacing: "0.08em", color: "var(--ink-3)" }}>
              PASSWORD
            </label>
            <input
              type="password" value={password} autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
              style={{
                fontFamily: "var(--mono)", fontSize: "0.875rem", padding: "0.55rem 0.75rem",
                border: "1px solid var(--hair)", borderRadius: 4, background: "var(--ground)",
                color: "var(--ink)", outline: "none",
              }}
            />
          </div>

          {error && (
            <div style={{
              fontFamily: "var(--mono)", fontSize: "0.6875rem", color: "#c0392b",
              background: "#fdecea", border: "1px solid #f0b8b8", borderRadius: 4,
              padding: "0.5rem 0.75rem",
            }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              fontFamily: "var(--mono)", fontSize: "0.75rem", letterSpacing: "0.1em",
              padding: "0.65rem 1rem", border: "none", borderRadius: 4, cursor: "pointer",
              background: "var(--ground)", color: "#ffffff", width: "100%",
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? "ACCESSO…" : "ACCEDI"}
          </button>
        </form>
      </div>
    </div>
  );
}
